// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"74f0a7bd","538":"aea56986","552":"3d341278","688":"61c8756f","787":"7ae1d169","893":"591be956","943":"55c8574b"}[chunkId] + ".chunk.js";
};